import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    customerModule: {},  // Changed from [] to {}
    productModule: {},   // Changed from [] to {}
    storeModule: {},     // Changed from [] to {}
    salesModule:{},
    employeeModule:{},
    vendorModule:{},
  
};

const customFieldSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {
    setCustomerModule: (state, action) => {
      state.customerModule = action.payload;
    },
    setProductModule: (state, action) => {
      state.productModule = action.payload;
    },
    setStoreModule: (state, action) => {
      state.storeModule = action.payload;
    },
    setSalesModule: (state, action) => {
      state.salesModule = action.payload;
    },
    setEmployeeModule: (state, action) => {
      state.employeeModule = action.payload;
    },
    setVendorModule: (state, action) => {
      state.vendorModule = action.payload;
    },
    // Add other module setters as needed
   
    // Optional: A setter for all modules at once
    setAllModules: (state, action) => {
      const { customer, product, store , sales , employee , vendor } = action.payload;
      state.customerModule = customer || [];
      state.productModule = product || [];
      state.storeModule = store || [];
      state.salesModule = sales || [];
      state.employeeModule = employee || [];
      state.vendorModule = vendor || [];

    }
  }
});

// Export actions
export const {
  setCustomerModule,
  setProductModule,
  setStoreModule,
  setSalesModule,
  setEmployeeModule,
  setVendorModule,
  setAllModules
} = customFieldSlice.actions;

// Export selectors
export const selectCustomerModule = (state) => state.customFields.customerModule;
export const selectProductModule = (state) => state.customFields.productModule;
export const selectStoreModule = (state) => state.customFields.storeModule;
export const selectSalesModule = (state) => state.customFields.salesModule;
export const selectEmployeeModule = (state) => state.customFields.employeeModule;
export const selectVendorModule = (state) => state.customFields.vendorModule;



// Export reducer
export default customFieldSlice.reducer;